import { useEffect } from 'react';
import { updateUserVisitorsData } from '../../../util/api';

export const useUpdateUserVisitors = ({
    riderListing,
    currentUserId,
    isOwnListing,
    currentUserIsRider,
    authorId,
    listingId,
}) => {
    useEffect(() => {
        /**
         * only available riders with complete profile
         * are allowed to become visitors
         */
        if (!riderListing) return;
        if (!currentUserId) return;
        if (isOwnListing) return;
        if (!currentUserIsRider) return;
        if (!authorId) return;
        /**
         * visitedEntryId - listingId
         * visitorRepresentationId - riderId
         */
        updateUserVisitorsData(authorId, listingId.uuid, currentUserId, 'horse');
    }, [currentUserId, currentUserIsRider, authorId, listingId.uuid, riderListing]);
};
